import SceneObject from "../scene/sceneobject";

export type JumpNodeKind = "ground" | "object";

export type JumpAnimKind =
  | "ground_to_object"
  | "object_to_object_across"
  | "object_to_object_up"
  | "object_to_object_down_low"
  | "object_to_object_down_high"
  | "object_to_ground";

export type JumpNode = {
  id: string;
  kind: JumpNodeKind;
  position: Float32Array;        // top-center world (for "ground", a dummy [0,0,0])
  surface_radius: number;        // min(half_x, half_z) of cap AABB
  source_object: SceneObject | null;
};

export type JumpEdge = {
  from: string;
  to: string;
  horizontal: number;
  vertical: number;
  anim: JumpAnimKind;
};

export type PuppyLocation =
  | { kind: "ground" }
  | { kind: "object"; node_id: string };

export const GROUND_NODE_ID = "ground";